var pym = require("./lib/pym");
require("./lib/webfonts");
var { isMobile } = require("./lib/breakpoints");
var { classify } = require("./lib/helpers");
var d3 = {
  ...require("d3-scale/dist/d3-scale.min"),
  ...require("d3-selection/dist/d3-selection.min"),
};

var onWindowLoaded = function() {
  renderCartogram({
    container: '#cartogram1',
    data: DATA, 
    type: 'trumpVisits'
  });
  renderCartogram({
    container: '#cartogram2',
    data: DATA, 
    type: 'harrisVisits'
  });

  renderNortheastSquares(DATA, 'trumpVisits', 'harrisVisits');
  renderLegend(DATA);
  colorGeoMap(DATA, TYPE, '#geographic-map1');
  colorGeoMap(DATA, TYPE, '#geographic-map2');
  renderGeoLabels(DATA, TYPE, '#geographic-map1');
  renderGeoLabels(DATA, TYPE, '#geographic-map2');

  document.querySelector('.controls').addEventListener('change', toggleMap);

  pym.then(child => {
    child.sendHeight();
    window.addEventListener("resize", () => {
      renderCartogram({
        container: '#cartogram1',
        data: DATA, 
        type: 'trumpVisits'
      });
      renderCartogram({
        container: '#cartogram2',
        data: DATA, 
        type: 'harrisVisits'
      });
      renderGeoLabels(DATA, TYPE, '#geographic-map1');
      renderGeoLabels(DATA, TYPE, '#geographic-map2');
      renderLegend(DATA);
      child.sendHeight();
    });
  });

  toggleMap({ srcElement: { id: "geography-mode" } });
};

var isSmall = window.matchMedia("(max-width: 450px)"),
  isMedium = window.matchMedia("(min-width: 451px) and (max-width: 750px)"),
  isBig = window.matchMedia("(min-width: 751px)");
var districts = ["NE-1", "NE-2", "NE-3", "NE-AL-A", "NE-AL-B", "ME-1", "ME-2", "ME-AL-A", "ME-AL-B"];
var northeastStates = ["VT", "NH", "MA", "CT", "RI", "NJ", "DE", "MD", "DC"];
var horizontalStates = ["NE", "ME", "KY", "TN"];
var cartogramEl = d3.select("#cartogram");
var geographicMapEl = d3.select("#geographic-map");
var geographicMapSvg = geographicMapEl.select("svg");

var toggleMap = function(e) {
  var target = e.srcElement.id;
  var cartogramContainer = d3.select("#cartogramContainer");
  var geographicContainer = d3.select("#geographicContainer");

  // Set the titles
  d3.select("#cartogram1-title").text("Trump's Trips");
  d3.select("#cartogram2-title").text("Harris' Trips");
  d3.select("#geographic-map1-title").text("Trump's Trips");
  d3.select("#geographic-map2-title").text("Harris' Trips");

  switch(target) {
    case "geography-mode":
      cartogramContainer.classed("active", false);
      geographicContainer.classed("active", true);
      break;
    case "cartogram-mode":
      cartogramContainer.classed("active", true);
      geographicContainer.classed("active", false);
      break;
  }

  pym.then(child => {
    child.sendHeight();
  });
};

var renderCartogram = function(config) {
  var containerElement = d3.select(config.container);
  containerElement.html('');
  var chartWidth = containerElement.node().offsetWidth,
    chartHeight = chartWidth * 0.68;

  var chartElement = containerElement.append("svg")
    .attr("width", chartWidth)
    .attr("height", chartHeight)
    .attr("viewBox", "0 0 705 475")
    .append("g");

  var scaleFactor = 200;
  var row = 0;
  var colPos = 0;
  
  // Render squares
  chartElement.append("g")
    .attr("class", "squares")
    .selectAll("rect")
    .data(config.data)
    .enter()
    .append("rect")
    .attr("class", d => classify(d.usps))
    .attr("width", d => Math.floor(Math.sqrt(d.electors * scaleFactor)))
    .attr("height", d => Math.floor(Math.sqrt(d.electors * scaleFactor)))
    .attr("x", d => d.cartoX)
    .attr("y", d => d.cartoY)
    .attr("fill", function(d) {
      var visitsType = config.type;
      var visits = d[visitsType] !== undefined ? parseInt(d[visitsType]) : undefined;
      return getColor(visits);
    });

  // Render main labels
  var cartoLabels = chartElement.append("g")
    .attr("class", "carto-labels")
    .selectAll("text")
    .data(config.data)
    .enter()
    .append("text")
    .text(d => d.usps)
    .attr("class", d => classify(d.id) + "-label")
    .attr("text-anchor", "middle")
    .attr("fill", d => {
      let visits = parseInt(d[config.type]);
      if (isNaN(visits) || visits === 0) {
        return "#000";
      } else if (TYPE === "march_july") {
        return visits > 3 ? "#dfefef" : "#000";
      } else if (TYPE === "july_sept") {
        return visits > 3 ? "#dfefef" : "#000";
      }
    })
    .attr("font-size", d => {
      if (isSmall.matches) {
        return d.electors > 3 ? 20 : 16;
      } else if (isMedium.matches) {
        return d.electors > 4 ? 15 : 12;
      } else {
        return d.electors > 4 ? 13 : 11;
      }
    })
    .attr("x", (d, i) => {
      if (d.usps === "NE") {
        return 209;
      } else if (d.usps === "ME") {
        return 660;
      } else {
        var x = d.cartoX;
        var width = Math.floor(Math.sqrt(d.electors * scaleFactor));
        return x + width / 2;
      }
    })
    .attr("y", (d, i) => {
      if (d.usps === "NE") {
        return isSmall.matches ? 228 : 232;
      } else if (d.usps === "ME") {
        return 20;
      } else {
        var y = d.cartoY;
        var height = Math.floor(Math.sqrt(d.electors * scaleFactor));
        return y + height / 2;
      }
    })
    .attr("dx", 0)
    .attr("dy", isMobile.matches ? 6 : -2);

  // Render elector labels
  if (!isMobile.matches) {
    chartElement.append("g")
      .attr("class", "carto-elector-labels")
      .selectAll("text")
      .data(config.data)
      .enter()
      .append("text")
      .text(d => {
        if (d.usps === "NE") {
          return "5";
        } else if (d.usps === "ME") {
          return "4";
        } else {
          return d.electors;
        }
      })
      .attr("class", d => classify(d.id) + "-elector-label")
      .attr("text-anchor", "middle")
      .attr("font-size", d => d.electors > 4 ? 11 : 8)
      .attr("x", (d, i) => {
        if (d.usps === "NE") {
          return 209;
        } else if (d.usps === "ME") {
          return 660;
        } else {
          var x = d.cartoX;
          var width = Math.floor(Math.sqrt(d.electors * scaleFactor));
          return x + width / 2;
        }
      })
      .attr("fill", d => {
        let visits = parseInt(d[config.type]);
        if (isNaN(visits) || visits === 0) {
          return "#000";
        } else if (TYPE === "march_july") {
          return visits > 3 ? "#dfefef" : "#000";
        } else if (TYPE === "july_sept") {
          return visits > 3 ? "#dfefef" : "#000";
        }
      })
      .attr("y", (d, i) => {
        if (d.usps === "NE") {
          return 240;
        } else if (d.usps === "ME") {
          return 28;
        } else {
          var y = d.cartoY;
          var height = Math.floor(Math.sqrt(d.electors * scaleFactor));
          var offset = d.electors > 4 ? 11 : 8;
          return y + height / 2 + offset;
        }
      });
  }
};

var renderNortheastSquares = function(data, trumpVisitsType, harrisVisitsType) {
  ['#geographic-map1', '#geographic-map2'].forEach((mapId, index) => {
    var geographicMapSvg = d3.select(mapId).select("svg");
    var visitsType = index === 0 ? trumpVisitsType : harrisVisitsType;
    
    var northeastStateGroups = geographicMapSvg.append("g")
      .selectAll("g")
      .data(northeastStates)
      .enter()
      .append("g")
      .attr("class", "northeast-state-group");

    northeastStateGroups.append("rect")
      .attr("id", d => classify(d) + "-square-" + (index + 1))
      .attr("width", 15)
      .attr("height", 15)
      .attr("x", 730)
      .attr("y", (d, i) => 210 + 20 * i)
      .attr("fill", d => {
        var stateData = data.find(state => state.usps === d);
        var visits = stateData ? stateData[visitsType] : undefined;
        return getColor(visits);
      })
  });
};

var renderGeoLabels = function(data, type, containerId) {
  var geographicMapEl = d3.select(containerId);
  var geographicMapSvg = geographicMapEl.select("svg");

  // Remove existing labels within this specific map
  geographicMapEl.selectAll(".geo-northeast-labels").remove();
  geographicMapEl.selectAll(".geo-elector-labels").remove();

  // Add northeast labels
  var geoNortheastLabels = geographicMapEl.selectAll(".northeast-state-group")
    .append("text")
    .attr("class", "geo-northeast-labels")
    .text(d => d + " ")
    .attr("font-size", isMobile.matches ? 18 : 12)
    .attr("x", 750)
    .attr("y", (d, i) => 223 + 20 * i);

  // Add labels for other states
  data.forEach(d => {
    if (northeastStates.indexOf(d.usps) != -1) {
      return;
    } else {
      var stateGroup = geographicMapSvg.select("." + classify(d.usps)),
        bounds = stateGroup.select("path").node().getBBox(),
        text = stateGroup.select("text"),
        xOffset = d.geoX ? d.geoX : 0,
        yOffset = d.geoY ? d.geoY : 0;
      
        text.attr("text-anchor", "middle")
        .attr("font-size", isMobile.matches ? 22 : 19)
        .attr("fill", data => {
          var type = containerId === "#geographic-map1" ? "trumpVisits" : "harrisVisits";
          let visits = parseInt(d[type]);
          if (isNaN(visits) || visits === 0) {
            return "#000";
          } else if (TYPE === "march_july") {
            return visits > 3 ? "#dfefef" : "#000";
          } else if (TYPE === "july_sept") {
            return visits > 3 ? "#dfefef" : "#000";
          }
        })
        .attr("x", bounds.x + bounds.width / 2 + xOffset)
        .attr("y", () => {
          if (isMobile.matches) {
            return bounds.y + bounds.height / 2 + yOffset + 8;
          } else {
            return bounds.y + bounds.height / 2 + yOffset;
          }   
        });
    }
  });
};

var renderLegend = function (data) {
  var legendContainer = d3.select("#choroplethLegend");
  legendContainer.html("");

  var legendData;
  if (TYPE === "march_july") {
    legendData = [
      { color: "#cccccc", label: "0 trips" },
      { color: "#dfefef", label: "1 trip" },
      { color: "#8BC0BF", label: "2-3 trips" },
      { color: "#17807E", label: "4-5 trips" }
    ];
  } else if (TYPE === "july_sept") {
    legendData = [
      { color: "#cccccc", label: "0 trips" },
      { color: "#dfefef", label: "1 trip" },
      { color: "#8BC0BF", label: "2-3 trips" },
      { color: "#17807E", label: "4-5 trips" }
    ];
  }

  var svg = legendContainer.append("svg")
    .attr("width", "90%")
    .attr("height", 60)
    .style("display", "block")
    .style("margin", "0 auto");

  var svgWidth = svg.node().getBoundingClientRect().width;
  var itemWidth = svgWidth / legendData.length;

  var legendItems = svg.append("g")
    .attr("class", "legend")
    .selectAll(".legend-item")
    .data(legendData)
    .enter()
    .append("g")
    .attr("class", "legend-item")
    .attr("transform", (d, i) => `translate(${i * itemWidth}, 25)`);

  legendItems.append("rect")
    .attr("width", itemWidth)
    .attr("height", 10)
    .attr("fill", d => d.color)
    .attr("stroke", "#000")
    .attr("stroke-width", 0);

  legendItems.append("text")
    .attr("x", itemWidth / 2)
    .attr("y", 24)
    .attr("text-anchor", "middle")
    .text(d => d.label)
    .attr("font-size", "12px")
    .attr("fill", "#666");
};

var getColor = function (visits) {
  visits = parseInt(visits);
  if (isNaN(visits) || visits === 0) return "#cccccc";

  if (TYPE === "march_july") {
    var bucketSize = 2;
    if (visits === 1) return "#dfefef";
    else if (visits >= 2 && visits <= 3) return "#8BC0BF";
    else if (visits >= 4 && visits <= 5) return "#17807E";
    else return "#0B403F";
  } else if (TYPE === "july_sept") {
    if (visits === 1) return "#dfefef";
    else if (visits >= 2 && visits <= 3) return "#8BC0BF";
    else if (visits >= 4 && visits <= 5) return "#17807E";
    else return "#0B403F";
  }
};

var colorGeoMap = function(data) {
  var tooltip = d3.select("body").append("div")
    .attr("class", "tooltip")
    .style("opacity", 0)
    .style("position", "absolute")
    .style("background-color", "white")
    .style("border", "solid")
    .style("border-width", "1px")
    .style("border-radius", "5px")
    .style("padding", "5px");

  var colorMap = function(mapId, visitsKey) {
    var mapEl = d3.select(mapId);
    data.forEach(d => {
      var stateEl = mapEl.select("." + classify(d.usps));
      var stateShape = stateEl.select("path");

      var visits = d[visitsKey] !== undefined ? parseInt(d[visitsKey]) : undefined;
      stateShape.attr("fill", getColor(visits))
        .attr("stroke", "white")
        .attr("stroke-width", "1");

      if (northeastStates.indexOf(d.usps) !== -1) {
        var el = mapEl.select("#" + classify(d.usps) + "-square");
        el.attr("fill", getColor(visits))
          .attr("stroke", "white")
          .attr("stroke-width", "1")
      }
    });
  };

  colorMap("#geographic-map1", "trumpVisits");
  colorMap("#geographic-map2", "harrisVisits");
};

// Initially load the graphic
// wait for images to load. see: https://developer.mozilla.org/en-US/docs/Web/API/Window/load_event
window.addEventListener("load", onWindowLoaded);